<div class="ai-visibility" *ngIf="aiVisibilityResponse">
  <!-- Loading/No Data State -->
  <div *ngIf="!hasData()" class="no-data-state">
    <div class="loading-message">
      <h4>AI Visibility Index</h4>
      <p>{{ getDataStatus() }}</p>
      <div class="loading-spinner" *ngIf="!aiVisibilityResponse">
        <div class="spinner"></div>
        <span>Loading AI Visibility data...</span>
      </div>
    </div>
  </div>

  <!-- Chart Content -->
  <div *ngIf="hasData()">
    <div class="education-overview-container">

      <!-- Top Row: Score Widget and Chart -->
      <div class="top-row">
        <!-- Composite Score Widget -->
        <app-composite-score-widget
          [compositeScore]="compositeScore"
          [title]="'AI Visibility Score'"
          [size]="'medium'">
        </app-composite-score-widget>

        <!-- AI Visibility Chart -->
        <div class="chart-section">
      <div class="chart-header">
        <div class="chart-title-section">
          <h4 class="chart-title">AI Visibility Index</h4>
          <p class="chart-subtitle">{{ getChartSubtitle() }}</p>
        </div>
      </div>


      <!-- All Universities - Combo Chart V2 (Single or Multiple) -->
      <div class="chart-mobile-wrapper">
        <div *ngIf="shouldShowComboChart()" class="combo-chart-wrapper">
          <app-bar-line-combo-chart
            [view]="view"
            [scheme]="comboBarScheme"
            [colorSchemeLine]="lineChartScheme"
            [results]="results"
            [lineChart]="lineChart"
            [barBrandName]="'Bar Chart'"
            [animations]="true"
            [tooltipDisabled]="false"
            [yAxisTickFormatting]="yLeftTickFormat"
            [yLeftAxisScaleFactor]="yLeftAxisScale"
            [yRightAxisScaleFactor]="yRightAxisScale"
            [yRightAxisTickFormatting]="yRightTickFormat"
            [gradient]="false"
            [xAxis]="true"
            [yAxis]="true"
            [legend]="true"
            [legendTitle]="'Universities'"
            [legendPosition]="'right'"
            [showGridLines]="true"
            [showXAxisLabel]="true"
            [showYAxisLabel]="true"
            [showRightYAxisLabel]="true"
            [xAxisLabel]="'AI Visibility Metrics'"
            [yAxisLabel]="'Score'"
            [yAxisLabelRight]="'Score'"
            [noBarWhenZero]="true"
            [wrapTicks]="false"
            (select)="onSelect($event)"
            (activate)="onActivate($event)"
            (deactivate)="onDeactivate($event)">
          </app-bar-line-combo-chart>
        </div>
      </div>

      </div> <!-- End of top-row -->
    </div> <!-- End of education-overview-container -->

    <!-- AI Visibility Comparison Table -->
    <div class="comparison-table-section" *ngIf="hasData()">
      <mat-card class="comparison-table-card">
        <mat-card-header>
          <mat-card-title>AI Visibility Comparison</mat-card-title>
          <mat-card-subtitle>Detailed metrics comparison across universities</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="table-container">
            <table class="ai-visibility-comparison-table">
              <thead>
                <tr>
                  <th class="university-column">University</th>
                  <th class="metric-column">AI Visibility Score</th>
                  <th class="metric-column">Content Quality</th>
                  <th class="metric-column">Digital Presence</th>
                  <th class="metric-column">Innovation Index</th>
                  <th class="metric-column">AI Adoption Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let university of aiVisibilityResponse.universities; let i = index"
                  [class.highlight-row]="isYouUniversity(university)" [class.first-row]="i === 0">
                  <td class="university-cell">
                    <div class="university-name">
                      {{ university.name }}
                      <span class="you-badge" *ngIf="isYouUniversity(university)">(YOU)</span>
                    </div>
                  </td>
                  <td class="metric-cell">
                    <div class="metric-value">{{ university.ai_visibility_score | number:'1.0-0' }}</div>
                    <div class="metric-bar">
                      <div class="metric-fill" [style.width.%]="university.ai_visibility_score"></div>
                    </div>
                  </td>
                  <td class="metric-cell">
                    <div class="metric-value">{{ university.content_quality | number:'1.0-0' }}</div>
                    <div class="metric-bar">
                      <div class="metric-fill" [style.width.%]="university.content_quality"></div>
                    </div>
                  </td>
                  <td class="metric-cell">
                    <div class="metric-value">{{ university.digital_presence | number:'1.0-0' }}</div>
                    <div class="metric-bar">
                      <div class="metric-fill" [style.width.%]="university.digital_presence"></div>
                    </div>
                  </td>
                  <td class="metric-cell">
                    <div class="metric-value">{{ university.innovation_index | number:'1.0-0' }}</div>
                    <div class="metric-bar">
                      <div class="metric-fill" [style.width.%]="university.innovation_index"></div>
                    </div>
                  </td>
                  <td class="metric-cell">
                    <div class="metric-value">{{ university.ai_adoption_rate | number:'1.0-0' }}</div>
                    <div class="metric-bar">
                      <div class="metric-fill" [style.width.%]="university.ai_adoption_rate"></div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Strengths and Areas for Improvement -->
    <div class="strengths-improvement-section" *ngIf="hasData()">
      <mat-card class="strengths-improvement-card">
        <mat-card-header>
          <mat-card-title>Strengths and Areas for Improvement</mat-card-title>
          <mat-card-subtitle>Comprehensive analysis of university performance</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="university-analysis-grid">
            <!-- Single University Analysis -->
            <div
              *ngIf="shouldShowBarChart() && aiVisibilityResponse.universities && aiVisibilityResponse.universities.length > 0"
              class="single-university-analysis">
              <div class="analysis-card">
                <div class="university-header">
                  <h4>{{ aiVisibilityResponse.universities[0].name || 'University' }}</h4>
                </div>

                <div class="strengths-section">
                  <div class="section-header">
                    <div class="section-indicator strengths-indicator"></div>
                    <h5>Strengths:</h5>
                  </div>
                  <ul class="analysis-list">
                    <li>Strong community links</li>
                    <li>Diverse curriculum</li>
                    <li>High student satisfaction</li>
                    <li>Industry connections</li>
                  </ul>
                </div>

                <div class="improvement-section">
                  <div class="section-header">
                    <div class="section-indicator improvement-indicator"></div>
                    <h5>Areas for Improvement:</h5>
                  </div>
                  <ul class="analysis-list">
                    <li>Lower research output</li>
                    <li>Limited international partnerships</li>
                    <li>High fees for international students</li>
                    <li>Competitive entry requirements</li>
                  </ul>
                </div>
              </div>
            </div>

            <!-- Multiple Universities Analysis -->
            <div *ngIf="shouldShowComboChart()" class="multiple-universities-analysis">
              <div class="university-analysis-card"
                *ngFor="let university of aiVisibilityResponse.universities; let i = index">
                <div class="university-header">
                  <h4>{{ university.name }}</h4>
                  <span class="you-badge" *ngIf="isYouUniversity(university)">(YOU)</span>
                </div>

                <div class="strengths-section">
                  <div class="section-header">
                    <div class="section-indicator strengths-indicator"></div>
                    <h5>Strengths:</h5>
                  </div>
                  <ul class="analysis-list">
                    <li *ngIf="i === 0">Strong community links</li>
                    <li *ngIf="i === 0">Diverse curriculum</li>
                    <li *ngIf="i === 1">Industry connections</li>
                    <li *ngIf="i === 1">High student satisfaction</li>
                    <li *ngIf="i > 1">Research excellence</li>
                    <li *ngIf="i > 1">Global partnerships</li>
                    <li>Innovative programs</li>
                    <li>Strong alumni network</li>
                  </ul>
                </div>

                <div class="improvement-section">
                  <div class="section-header">
                    <div class="section-indicator improvement-indicator"></div>
                    <h5>Areas for Improvement:</h5>
                  </div>
                  <ul class="analysis-list">
                    <li *ngIf="i === 0">Lower research output</li>
                    <li *ngIf="i === 0">Limited international partnerships</li>
                    <li *ngIf="i === 1">High fees for international students</li>
                    <li *ngIf="i === 1">Competitive entry requirements</li>
                    <li *ngIf="i > 1">Limited local industry ties</li>
                    <li *ngIf="i > 1">Smaller class sizes</li>
                    <li>Technology infrastructure</li>
                    <li>Student support services</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

    <!-- Context Sources -->
    <div class="citations-section" *ngIf="aiVisibilityResponse.context.citations?.length">
      <h4>Context Sources:</h4>
      <app-common-sources
        [evidenceSources]="transformCitationsToEvidenceSources(aiVisibilityResponse.context.citations)"
        [title]="'Data Sources & Evidence'" [showTitle]="false">
      </app-common-sources>
    </div>







    <!-- region hidden-section -->

    <!-- AI Visibility Analysis -->
    <!-- <div class="context-section" style="display: none;">
    <mat-card class="context-card">
      <mat-card-header>
        <mat-card-title>AI Visibility Analysis</mat-card-title>
      </mat-card-header>
      <mat-card-content>
        Insights -->
    <!-- <div class="insights" *ngIf="aiVisibilityResponse?.context?.insights?.length">
          <h4>Key Insights:</h4>
          <div class="insights-list">
            <div class="insight-item" *ngFor="let insight of aiVisibilityResponse.context.insights">
              <mat-icon>lightbulb</mat-icon>
              <span>{{ insight }}</span>
            </div>
          </div>
        </div> -->
    <!-- </mat-card-content>
    </mat-card>
    </div> -->

    <!-- Detailed AI Visibility Metrics -->
    <!-- <div class="metrics-section" style="display: none;">
      <mat-card class="metrics-card">
        <mat-card-header>
          <mat-card-title>Detailed AI Visibility Metrics</mat-card-title>
          <mat-card-subtitle>Comprehensive breakdown of AI adoption metrics</mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
          <div class="metrics-table">
            <table class="ai-metrics-table">
              <thead>
                <tr>
                  <th>University</th>
                  <th>AI Visibility Score</th>
                  <th>Content Quality</th>
                  <th>Digital Presence</th>
                  <th>Innovation Index</th>
                  <th>AI Adoption Rate</th>
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let university of aiVisibilityResponse.universities">
                  <td>{{ university.name }}</td>
                  <td>{{ university.ai_visibility_score | number:'1.0-1' }}</td>
                  <td>{{ university.content_quality | number:'1.0-1' }}</td>
                  <td>{{ university.digital_presence | number:'1.0-1' }}</td>
                  <td>{{ university.innovation_index | number:'1.0-1' }}</td>
                  <td>{{ university.ai_adoption_rate | number:'1.0-1' }}%</td>
                </tr>
              </tbody>
            </table>
          </div>
        </mat-card-content>
      </mat-card>
    </div> -->

    <!-- Analysis Information -->
    <!-- <div class="meta-section">
      <mat-card class="meta-card">
        <mat-card-header>
          <mat-card-title>Analysis Information</mat-card-title>
        </mat-card-header>
        <mat-card-content>
          <div class="meta-grid">
            <div class="meta-item">
              <strong>Universities Analyzed:</strong>
              <div class="university-list">
                <span class="university-chip" *ngFor="let university of aiVisibilityResponse.universities">
                  {{ university.name }}
                </span>
              </div>
            </div>
            <div class="meta-item">
              <strong>Model Used:</strong> {{ aiVisibilityResponse.model_meta.model_used }}
            </div>
            <div class="meta-item">
              <strong>Search Engines:</strong>
              <div class="engine-chips">
                <span class="engine-chip" *ngFor="let engine of aiVisibilityResponse.model_meta.search_engines">
                  {{ engine }}
                </span>
              </div>
            </div>
            <div class="meta-item">
              <strong>Data Freshness:</strong> {{ aiVisibilityResponse.model_meta.data_freshness }}
            </div>
            <div class="meta-item">
              <strong>Processing Time:</strong> {{ aiVisibilityResponse.model_meta.processing_time }}s
            </div>
            <div class="meta-item">
              <strong>Analysis Time:</strong> {{ aiVisibilityResponse.timestamp | date:'medium' }}
            </div>
          </div>
        </mat-card-content>
      </mat-card>
    </div> -->

    <!-- endregion hidden-section -->
  </div>
</div>
<!-- </div> -->
